<template>
  <list-page>
    <h1 slot="model">新闻资讯</h1>
    <h3 slot="model_y">NEWS INFORMATION</h3>
      <template slot="list">
         <!-- v-if="newsData1.length != 0" -->
        <list>
          <div class="newtitle" slot="title">
            <p>公司动态<span>News & Information</span> </p>
            <router-link :to="'/NewPageList/1'"><span>MORE</span></router-link>
          </div>
          <template slot="listitem">
            <el-skeleton :loading="loading1">
              <template slot="template">
                <list-item-gj></list-item-gj>
                <list-item-gj></list-item-gj>
              </template>
              <template>
                <router-link :to="'/NewDetail/'+ item.id" target="_blank"
                  v-for="(item,index) in newsData1" :key="item+'-'+index"
                  v-if="index < 2">
                  <list-item :item="item"></list-item>
                </router-link>
              </template>
            </el-skeleton>
          </template>
        </list>
         <!-- v-if="newsData2.length != 0" -->
        <list>
          <div class="newtitle" slot="title">
            <p>行业新闻<span>News & Industry</span> </p>
            <router-link :to="'/NewPageList/2'"><span>MORE</span></router-link>
          </div>
          <template slot="listitem">
            <router-link :to="'/NewDetail/'+ item.id" target="_blank"
              v-for="(item,index) in newsData2" :key="item+'-'+index"
              v-if="index < 2">
              <list-item :item="item"></list-item>
            </router-link>
          </template>
        </list>
      </template>
  </list-page>
</template>
  
<script>
  import  listPage from '@/view/components/listPage.vue'
  import  list from '@/view/components/list.vue'
  import  listItem from '@/view/components/listItem.vue'
  import  listItemGj from '@/view/components/listItemGj.vue'

import News from '@/api/api.js'

export default {
  data() {
    return {
      newsData1: [],
      newsData2: [],
      
      loading1: true,
    };
  },
  components: {
    listPage,
    list,
    listItem,
    listItemGj
  },
  created() {
    this.getData(1)
    this.getData(2)
  },
  mounted() {
  },
  methods: {
    async getData(classId){
      this.searchDTO = {
        limit: 2,
        classId  //新闻分类
      };
      let res =await News.getNewList(this.searchDTO);
      this['newsData'+classId] = res.data;
      this['loading'+classId] = false
      // console.log('newsData'+classId,this['newsData'+classId])
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/view/webapp/NewPageAll.vue